module.exports = __webpack_public_path__ + "dca8c6b29ff5f5a38d000d88b4be8f3f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-28.png
// module id = 3105
// module chunks = 0